export default "__VITE_ASSET__Aq2RN6zw__"